/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import SaveTaskTab from "./Tabs/SaveTaskTab";
import ViewTaskTab from "./Tabs/ViewTaskTab";
import LogTab from "./Tabs/LogTab";
import AlertNotification from "../AlertNotification/AlertNotification";
import NoteSection from "../NoteComponent/NoteSection";
import HistoryCard from "../HistoryCard/HistoryCard";

const SaveTaskBody = () => {
  const params = useParams();

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const [showTaskTab, setshowTaskTab] = useState(false);
  const [showLogTab, setshowLogTab] = useState(false);

  const [showTaskEditForm, setShowTaskEditForm] = useState(false);

  const [noteAccessUserList, setnoteAccessUserList] = useState([]);

  const [taskHistory, setTaskHistory] = useState([]);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //* Switch between task and log tab based on the tabName parameter */
  const switchTabs = (tabName) => {
    setshowTaskTab(false);
    setshowLogTab(false);
    if (tabName == "task") {
      setshowTaskTab(true);
    }
    if (tabName == "log") {
      setshowLogTab(true);
    }
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    switchTabs("task");
  }, []);

  return (
    <div id="content_wrapper">
      <section className="crm-wrapper bg-white pb-5 pt-3">
        <div className="container-fluid px-lg-5">
          <div className="row">
            <div className="col-lg-8 mb-4 mb-lg-0">
              <div className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
                <ul className="nav nav-tabs w-100 flex-nowrap fs-sm lh-1 fw-semibold text-center border-0 text-nowrap overflow-auto mt-3">
                  {/* task tab title */}
                  <li className="nav-item flex-fill" role="presentation">
                    <Link
                      to="#"
                      className={`text-black d-block px-3 py-3 position-relative ${
                        showTaskTab && "active"
                      }`}
                      onClick={() => {
                        switchTabs("task");
                      }}
                    >
                      {t("Tasks Details")}
                    </Link>
                  </li>
                  {/* log tab title */}

                  {params.id && (
                    <li className="nav-item flex-fill" role="presentation">
                      <Link
                        to="#"
                        className={`text-black d-block px-3 py-3 position-relative ${
                          showLogTab && "active"
                        }`}
                        onClick={() => {
                          switchTabs("log");
                        }}
                      >
                        {t("Logs")}
                      </Link>
                    </li>
                  )}
                </ul>

                <div className="tab-content h-100" id="myTabContent">
                  {/* task view tab */}
                  {showTaskTab ? (
                    showTaskEditForm ? (
                      <SaveTaskTab
                        moduleName={"taskdetails"}
                        setShowAlert={setShowAlert}
                        setAlertMessage={setAlertMessage}
                        setMessageType={setMessageType}
                        setShowTaskEditForm={setShowTaskEditForm}
                        setnoteAccessUserList={setnoteAccessUserList}
                        setTaskHistory={setTaskHistory}
                      />
                    ) : (
                      <ViewTaskTab
                        setShowTaskEditForm={setShowTaskEditForm}
                        setShowAlert={setShowAlert}
                        setAlertMessage={setAlertMessage}
                        setMessageType={setMessageType}
                        setnoteAccessUserList={setnoteAccessUserList}
                        setTaskHistory={setTaskHistory}
                      />
                    )
                  ) : null}

                  {/* log tab */}
                  {showLogTab && (
                    <LogTab
                      setShowAlert={setShowAlert}
                      setAlertMessage={setAlertMessage}
                      setMessageType={setMessageType}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <NoteSection
                noteAccessUserList={noteAccessUserList}
                taskId={params.id}
                setShowAlert={setShowAlert}
                setAlertMessage={setAlertMessage}
                setMessageType={setMessageType}
              />

              <div className="mt-4 bg-white border border-gray-300 rounded-15 shadow-lg overflow-hidden">
                <div
                  className="px-4 py-3 border-bottom border-gray-300"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <span className="material-symbols-outlined text-white fs-md">
                        history
                      </span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 text-dark">{t("History")}</h4>
                      <p className="fs-sm text-muted mb-0">
                        {t("Recent changes and updates")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  {taskHistory.length > 0 ? (
                    <div className="notes-container">
                      {taskHistory.map((historyItem, index) => (
                        <HistoryCard
                          historyItem={historyItem}
                          t={t}
                          key={index}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div
                        className="p-4 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span
                          className="material-symbols-outlined text-muted"
                          style={{ fontSize: "2rem" }}
                        >
                          history
                        </span>
                      </div>
                      <h6 className="fw-bold text-muted mb-2">
                        {t("No History Yet")}
                      </h6>
                      <p className="text-muted mb-0">
                        {t("Changes will appear here")}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default SaveTaskBody;
